import React from 'react';
import { FaEnvelope } from 'react-icons/fa'; // Necesitas instalar react-icons
import '../styles/FloatingEmailButton.css';

export default function FloatingEmailButton() {
  return (
    <a
      href="mailto:info@garciaborreguero.com"
      className="floating-email-btn"
    >
      <FaEnvelope />
    </a>
  );
}